import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'take',
    standalone: true
})
export class TakePipe implements PipeTransform {

  transform(values: {}[], take: number) {
    return values.slice(0, take);
  }
}
